import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import AdyenCheckout from '@adyen/adyen-web';
import { confirmPayment } from './XceedClient';
export var confirmRedirectPay = function confirmRedirectPay(sessionId, redirectResult, paymentId, onSuccess, onFailure, checkoutHost, clientKey, environment) {
  var confirm = function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
      var res, _yield$res$json, data, success, error;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return confirmPayment(paymentId, redirectResult, checkoutHost, clientKey);
          case 2:
            res = _context.sent;
            _context.next = 5;
            return res.json();
          case 5:
            _yield$res$json = _context.sent;
            data = _yield$res$json.data;
            success = _yield$res$json.success;
            error = _yield$res$json.error;
            if (success) onSuccess(data);else onFailure(error);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function confirm() {
      return _ref.apply(this, arguments);
    };
  }();
  var fetchData = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(configuration, redirectResult) {
      var checkout;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return AdyenCheckout(configuration);
          case 2:
            checkout = _context2.sent;
            checkout.submitDetails({
              details: {
                redirectResult: redirectResult
              }
            });
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function fetchData(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  if (!!sessionId && !!redirectResult && !!paymentId) {
    var configuration = {
      environment: environment,
      clientKey: clientKey,
      locale: 'es_ES',
      showPayButton: false,
      session: {
        id: sessionId
      },
      onPaymentCompleted: function onPaymentCompleted(result, component) {
        if (result.resultCode === 'Authorised') confirm();else onFailure(new Error('Impossible to pay!'));
      },
      onError: function onError(error, component) {
        onFailure(error);
      }
    };
    fetchData(configuration, redirectResult)["catch"](function () {});
  }
};